module.exports = __webpack_public_path__ + "static/media/video_thumb4.527bc2f3.svg";